/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { CollectionValueModel } from './collection-value-model';
import { DataReactionAction } from './data-reaction-action';
import { DataReactionRelatedEntities } from './data-reaction-related-entities';
import { DataReactionSourceEntity } from './data-reaction-source-entity';
import { DataReactionSpaceScope } from './data-reaction-space-scope';
import { DataReactionValidation } from './data-reaction-validation';
import { FilterExpression } from './filter-expression';
import { LocalizedValue } from './localized-value';
import { ReferenceProperty } from './reference-property';

/**
 * (tsType: DataReactionWithRelations, schemaOptions: { includeRelations: true })
 */
export class DataReactionWithRelations {
  actions: Array<DataReactionAction>;
  creationInfo?: ActionInfo;
  criteria?: null | FilterExpression;
  definingEntity: ReferenceProperty;
  disabled?: boolean;
  eventConfig?: any;
  eventType: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 20 | 100;
  executorType?: null | CollectionValueModel;
  id?: string;
  isImplicit?: boolean;
  loopThreshold?: number;
  name: LocalizedValue;
  query?: ReferenceProperty;
  relatedEntities?: Array<null | DataReactionRelatedEntities>;
  sourceEntity?: null | DataReactionSourceEntity;
  spaceScope: DataReactionSpaceScope;
  specificationVersion: number;
  type: 0 | 1;
  updateIdentifier: string;
  updateInfo?: ActionInfo;
  validations?: null | DataReactionValidation;
}
